var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolToken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.17077 12.7565C6.20842 12.7151 6.25427 12.682 6.30542 12.6594C6.35652 12.6367 6.41187 12.625 6.46777 12.625L15.6318 12.6325C15.6708 12.6326 15.709 12.644 15.7416 12.6653C15.7743 12.6867 15.8001 12.7171 15.8158 12.7528C15.8315 12.7885 15.8365 12.828 15.8302 12.8665C15.8239 12.905 15.8066 12.9409 15.7803 12.9697L13.8288 15.1185C13.7911 15.1599 13.7452 15.193 13.6941 15.2156C13.6429 15.2383 13.5875 15.25 13.5315 15.25L4.36778 15.2425C4.32875 15.2424 4.29059 15.231 4.25792 15.2096C4.22526 15.1883 4.1995 15.1579 4.18377 15.1222C4.16805 15.0865 4.16303 15.0469 4.16933 15.0084C4.17563 14.9699 4.19299 14.9341 4.21928 14.9052L6.17077 12.7565ZM15.7803 10.9677C15.8066 10.9966 15.8239 11.0324 15.8302 11.071C15.8365 11.1094 15.8315 11.149 15.8158 11.1847C15.8001 11.2204 15.7743 11.2508 15.7416 11.2721C15.709 11.2935 15.6708 11.3049 15.6318 11.305L6.46802 11.3125C6.41207 11.3125 6.35672 11.3008 6.30552 11.2781C6.25432 11.2555 6.20842 11.2224 6.17077 11.181L4.21928 9.031C4.19299 9.00215 4.17563 8.9663 4.16933 8.9278C4.16303 8.8893 4.16805 8.84975 4.18377 8.81405C4.1995 8.77835 4.22526 8.74795 4.25792 8.7266C4.29059 8.70525 4.32875 8.69385 4.36778 8.69375L13.5318 8.68625C13.5877 8.6863 13.643 8.698 13.6942 8.72065C13.7453 8.7433 13.7912 8.77635 13.8288 8.81775L15.7803 10.9677ZM6.17077 4.8815C6.20842 4.84011 6.25427 4.80704 6.30542 4.78439C6.35652 4.76175 6.41187 4.75003 6.46777 4.75L15.6318 4.7575C15.6708 4.75758 15.709 4.76899 15.7416 4.79034C15.7743 4.8117 15.8001 4.84208 15.8158 4.8778C15.8315 4.91352 15.8365 4.95303 15.8302 4.99154C15.8239 5.03005 15.8066 5.0659 15.7803 5.09475L13.8288 7.2435C13.7911 7.2849 13.7452 7.318 13.6941 7.34065C13.6429 7.3633 13.5875 7.375 13.5315 7.375L4.36778 7.3675C4.32875 7.3674 4.29059 7.356 4.25792 7.33465C4.22526 7.3133 4.1995 7.2829 4.18377 7.2472C4.16805 7.2115 4.16303 7.17195 4.16933 7.13345C4.17563 7.09495 4.19299 7.0591 4.21928 7.03025L6.17077 4.8815Z",
    fill: "url(#paint0_linear_2019_545)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2019_545",
    x1: 4.52078,
    y1: 15.479,
    x2: 15.4788,
    y2: 4.521,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#7962E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D18C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolToken);
export default __webpack_public_path__ + "static/media/SOL-token.c763abdff7d3a37293e35ebab0a22901.svg";
export { ForwardRef as ReactComponent };